import React, { useEffect, useState } from "react";
import { Navigate, useNavigate, useLocation } from 'react-router-dom';
import { buildApiUrl } from './config.js';

function PrivateRoute({ element, allowedRoles }) {
    const token = localStorage.getItem('token');
    const userRole = localStorage.getItem('role');
    const navigate = useNavigate();
    const location = useLocation();
    const [isValidSession, setIsValidSession] = useState(true);

    const handleSessionInvalidation = () => {
        localStorage.removeItem('token');
        localStorage.removeItem('role');
        localStorage.removeItem('userId');
        setIsValidSession(false);
        navigate('/login', { replace: true });
    };

    const verifyToken = async () => {
        if (!token) {
            handleSessionInvalidation();
            return;
        }

        try {
            const response = await fetch(
                buildApiUrl("/api/users/protected-route"),
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            
            if (!response.ok) {
                const data = await response.json();
                if (data.message === "Session invalid. Please log in again.") {
                    handleSessionInvalidation();
                }
            }
        } catch (error) {
            handleSessionInvalidation();
        }
    };

    useEffect(() => {
        if (token) {
            verifyToken();
        } else {
            handleSessionInvalidation();
        }
    }, [token, location.pathname]);

    if (!token || !isValidSession) {
        return <Navigate to="/login" replace />;
    }

    if (allowedRoles && !allowedRoles.includes(userRole)) {
        return <Navigate to="/" replace />;
    }

    return element;
}

export default PrivateRoute;